import { render, staticRenderFns } from "./SmallStempelkarte.vue?vue&type=template&id=84b4af62&scoped=true"
import script from "./SmallStempelkarte.vue?vue&type=script&lang=js"
export * from "./SmallStempelkarte.vue?vue&type=script&lang=js"
import style0 from "./SmallStempelkarte.vue?vue&type=style&index=0&id=84b4af62&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b4af62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84b4af62')) {
      api.createRecord('84b4af62', component.options)
    } else {
      api.reload('84b4af62', component.options)
    }
    module.hot.accept("./SmallStempelkarte.vue?vue&type=template&id=84b4af62&scoped=true", function () {
      api.rerender('84b4af62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/stempelkarte/SmallStempelkarte.vue"
export default component.exports